var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.938,
    height: 16.938,
    viewBox: "0 0 16.938 16.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V_Green",
    "data-name": "V Green",
    transform: "translate(-4617.793 11005.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11251",
    "data-name": "Path 11251",
    d: "M8.469,0A8.469,8.469,0,1,1,0,8.469,8.469,8.469,0,0,1,8.469,0Z",
    transform: "translate(4617.793 -11005.145)",
    fill: "#28c79d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12283",
    "data-name": "Path 12283",
    d: "M-19880.152,12940.426l2.447,2.49,4.389-5.254",
    transform: "translate(24502.998 -23936.965)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVGreen);
export default __webpack_public_path__ + "static/media/vGreen.e77f9d219bcd572476ebedea76b61c09.svg";
export { ForwardRef as ReactComponent };